<template>
  <v-container class="margen_paginas pt-7" fluid>

    <TablaDatosAPI
      ref="tabla"
      :titulo="$t ('Registro de interfonía')"
      icono="mdi-phone-log"
      tabla="reginthor"
      :campos="['fechorlla+', 'id_disintori', 'id_disintdes', 'fechorini', 'fechorfin', 'durlla', 'id_ope']"
      :campos-filtrables="['fechorlla', 'id_tipeveint', 'id_disintori', 'id_disintdes', 'id_ope']"
      busqueda-rapida
      :filas-por-pagina="20"
      :segundos-auto-refresco="60"
      accionesPersonalizadas
      dense
      :eventoDobleClickFila="gestionarLlamada"
    >
      <template v-slot:[`item.fechorlla__VT`]="{ item }">
        <v-icon v-if="item.llaaba" color="#cccccc" >mdi-phone-alert</v-icon>
        <v-icon v-else color="#dfb750" class="mr-1" :class="{parpadeo: !item.fechorini && item.llaaba!=1 }">mdi-phone-ring</v-icon>
        {{formatearFechaHora (item.fechorlla)}}
      </template>

      <template v-slot:[`item.fechorini__VT`]="{ item }">
        <span v-if="item.fechorini">
          <v-icon color="#65b567" class="mr-1" :class="{parpadeo: !item.fechorfin && item.llaaba!=1 }">mdi-phone</v-icon>
          {{formatearHora (item.fechorini)}}
        </span>
        <span v-else>
          -
        </span>
      </template>

      <template v-slot:[`item.fechorfin__VT`]="{ item }">
        <span v-if="item.fechorfin">
          <v-icon color="#df5349" class="mr-1">mdi-phone-hangup</v-icon>
          {{formatearHora (item.fechorfin)}}
        </span>
        <span v-else>
          -
        </span>
      </template>

      <template v-slot:[`item.durlla`]="{ item }">
        <span v-if="item.fechorini && item.durlla">
          {{formatearDuracion (item.durlla)}}
        </span>
        <div v-else-if="item.fechorini && !item.fechorfin && item.llaaba!=1" class="mx-auto" style="width: 30%">
          <v-progress-linear
            buffer-value="0"
            color="green"
            reverse
            stream
            value="0"
          ></v-progress-linear>
        </div>
        <span v-else>
          -
        </span>
      </template>

      <template v-slot:[`item.id_ope__VT`]="{ item }">
        <span v-if="item.id_ope">
          {{item.id_ope__VT}}
        </span>
        <span v-else>
          -
        </span>
      </template>

      <template v-slot:accionesPersonalizadas="{item}">
        <v-icon small color="primary" class="mr-2" @click="gestionarLlamada (item)">mdi-face-agent</v-icon>
      </template>
    </TablaDatosAPI>
  </v-container>
</template>

<script>
import TablaDatosAPI from "@/components/TablaDatosAPI.vue";
import { DateTime, Duration } from "luxon";
import menu from "@/menu";

export default {
  components: { TablaDatosAPI },
  data() {
    return {
      manejadorNotificacionesInterfonia: null
    }
  },
  methods: {
    gestionarLlamada (item) {
      if (item.id_disintori > 0) {
        this.$global.identificadorInterfoniaAGestionar = item.id_disintori;
        this.$router.push ( { path: '/panel/asistenciaRemota' } );
      }
    },
    formatearFechaHora(fechahora) {
      return DateTime.fromSQL (fechahora).setLocale("es").toFormat('dd-MM-yyyy HH:mm:ss');
    },
    formatearHora(fechahora) {
      return DateTime.fromSQL (fechahora).setLocale("es").toFormat('HH:mm:ss');
    },
    formatearDuracion(segundos) {
      if (segundos < 60)
        return segundos + " s.";
      else
        return Duration.fromObject ({seconds: segundos}).toFormat('mm:ss');
    },
    procesarMensajeInterfonia () {
      this.$refs.tabla.actualizarDatos ();
    }
  },
  created() {
    this.manejadorNotificacionesInterfonia = this.$sagabroker.anadirEscuchadorTema ("central_interfonia/llamadas", this.procesarMensajeInterfonia);
    menu.obtenerElementoRuta ('/panel/registroInterfonia').notificaciones = 0;
  },
  destroyed () {
    this.$sagabroker.eliminarEscuchadorTema (this.manejadorNotificacionesInterfonia);
    menu.obtenerElementoRuta ('/panel/registroInterfonia').notificaciones = 0;
  }
};
</script>

<style>
.parpadeo {
  animation: parpadeo 1s linear infinite;
}

@keyframes parpadeo {
  50% { opacity: 1; }
  70% { opacity: 0; }
  100% { opacity: 1; }
}
</style>